export var POPUP_INIT = 'POPUP_INIT';
export function openPreviewPopup(isOpened) {
    return function (dispatch) {
        dispatch({
            type: POPUP_INIT,
            payload: isOpened
        });
    };
}
//# sourceMappingURL=openPreviewPopup.js.mapexport var POPUP_INIT = 'POPUP_INIT';
export function openPreviewPopup(isOpened) {
    return function (dispatch) {
        dispatch({
            type: POPUP_INIT,
            payload: isOpened
        });
    };
}
//# sourceMappingURL=openPreviewPopup.js.map